import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  // Estado para mensajes internos
  const [status, setStatus] = useState({ type: '', msg: '' });
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', msg: '' }); // Limpiar mensajes previos

    try {
      await api.post('/users/forgot-password', { email });
      
      setStatus({ 
        type: 'success', 
        msg: '📧 Código enviado. Revisa tu correo.' 
      });

      // Redirigimos después de un pequeño delay para que vea el mensaje de éxito
      setTimeout(() => navigate('/reset-password'), 2000);
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'No pudimos procesar la solicitud';
      setStatus({ 
        type: 'error', 
        msg: `❌ ${errorMsg}` 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-indigo-600 to-purple-700 p-4">
      <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md text-center">
        <h2 className="text-3xl font-bold text-gray-800 mb-2">¿Olvidaste tu clave?</h2>
        <p className="text-gray-500 mb-6 text-sm">Ingresa tu correo para recibir un código de seguridad.</p>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* MENSAJE DE ESTADO INTEGRADO */}
          {status.msg && (
            <div className={`p-3 rounded-xl text-sm font-medium animate-pulse border ${
              status.type === 'success' 
                ? 'bg-green-50 text-green-700 border-green-200' 
                : 'bg-red-50 text-red-700 border-red-200'
            }`}>
              {status.msg}
            </div>
          )}

          <input
            type="email"
            placeholder="ejemplo@correo.com"
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none transition"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button
            disabled={loading || status.type === 'success'}
            className="w-full bg-indigo-600 text-white py-3 rounded-xl font-bold hover:bg-indigo-700 disabled:bg-gray-400 transition shadow-lg flex justify-center items-center"
          >
            {loading ? (
              <>
                <svg className="animate-spin h-5 w-5 mr-3 text-white" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Enviando...
              </>
            ) : 'Enviar Código'}
          </button>
        </form>

        <div className="mt-6">
          <Link to="/login" className="text-indigo-600 hover:underline text-sm font-semibold transition-colors">
            ← Volver al inicio de sesión
          </Link>
        </div>
      </div>
    </div>
  );
}